import React from "react";
import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";

// Попап ПОДРОБНЕЕ индивидуальной (пустой) анкеты: длинный текст из ТЗ
// «Что такое чистая анкета?…». Открывается из 7-й зоны, из ЛК и из итогов.
export default function BlankFormDetailsModal() {
  const { t } = useTranslation();
  const paragraphs = t("blank_form.details.paragraphs", {
    returnObjects: true,
  });

  return (
    <BaseModal
      className="blank-form-details-modal"
      eventTypeModal={MODAL_TYPES.BLANK_FORM_DETAILS}
      title={t("blank_form.details.title")}
      description={
        <span
          style={{
            whiteSpace: "pre-line",
            textAlign: "left",
            display: "block",
            maxHeight: "55vh",
            overflowY: "auto",
          }}
        >
          {Array.isArray(paragraphs)
            ? paragraphs.join("\n\n")
            : String(paragraphs)}
        </span>
      }
    />
  );
}
